import Config from "config";
import { appMonitor } from "../../../../shared/util/services/metrics/analytics";

export const analytics = appMonitor({
  appId: Config.RUM_APP_ID,
  guestRoleArn: Config.RUM_ROLE_ARN,
  identityPoolId: Config.RUM_IDPOOL_ID,
});
